import React from "react";

export const links = [
    {
        href: 'https://radamou.github.io/porfolio/',
        id: 'porfolio-tooltip',
        tooltip: 'Porfolio',
        color: 'transparent',
        target: '_blank',
        icon: ' fas fa-graduation-cap'
    },
    {
        href: 'https://github.com/radamou',
        id: 'github-tooltip',
        tooltip: 'link to github',
        color: 'transparent',
        target: '_blank',
        icon: ' fab fa-github'
    },
    {
        href: 'https://twitter.com/ramatou2015',
        id: 'twitter-tooltip',
        tooltip: 'Follow me on twitter',
        color: 'transparent',
        target: '_blank',
        icon: ' fab fa-twitter'
    },
    {
        href: 'https://www.instagram.com/ramatouadamouissa/?hl=fr',
        tooltip: 'Follow me on Instagram',
        id: 'insatgram-tooltip',
        color: 'transparent',
        target: '_blank',
        icon: ' fab fa-instagram'
    },
    {
        href: 'https://www.facebook.com/rama.rai.77?ref=bookmarks',
        id: 'facebook-tooltip',
        tooltip: 'Follow me on facebook',
        color: 'transparent',
        target: '_blank',
        icon: ' fab fa-facebook'
    },
];